﻿import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basiscs/tk.manager';
import TKButtonDropdown from '@tk/controls/tk.button.dropdown';
import TKHeader from '@tk/components/tk.header';
import TKViewport from '@tk/basiscs/tk.viewport';
import TKBasketButton from '@tk/components/tk.basket.button';
import TKCarousel from '@tk/components/tk.carousel';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKMinibasket from '@tk/components/tk.minibasket';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import TKDialog from '@tk/components/tk.dialog';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKCompareListLink from '@tk/components/tk.compare.list.link';
import TKCompareButton from '@tk/components/tk.compare.button';
import TKSelection from '@tk/controls/tk.selection';
import TKFormTimepicker from '@tk/controls/tk.form.timepicker';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';
import TKFormZipCity from '@tk/controls/tk.form.zipcity';
import TKTable from '@tk/components/tk.table';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import KWSearch from '@/controls/kw.search';
import KWArticleList from '@/components/kw.article.list';
import KWStock from '@/components/kw.stock';
import KWPrice from '@/components/kw.price';
import KWScan from '@/components/kw.scan';
import KWFileUploadArea from '@/components/kw.file.upload.area';
import KWFormElement from '@/components/kw.form.element';
import KWAsync from '@/components/kw.async';
import KWSectionToggler from '@/components/kw.section.toggler';
import KWDialog from '@/components/kw.dialog';
import KWTourSchedule from '@/components/kw.tour.schedule';
import KWFavoriteButton from '@/components/kw.favorite.button';
import KWFormTracker from '@/components/kw.form.tracker';
import KWTabsTab from '@/components/kw.tabs.tab';

import 'flatpickr/dist/flatpickr.min.css';
import 'tippy.js/dist/tippy.css';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@scss/modules/cv-ces.scss';
import '@scss/modules/staticcontent.scss';

export default class Staticcontent extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'kw-form-tracker', constructor: KWFormTracker },
            { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'tk-search', constructor: KWSearch },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-minibasket', constructor: TKMinibasket },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-article-list', constructor: KWArticleList },
            { name: 'tk-price', constructor: KWPrice },
            { name: 'tk-stock', constructor: KWStock },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-favorite-button', constructor: KWFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-list-link', constructor: TKCompareListLink },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'kw-form-element', constructor: KWFormElement },
            { name: 'kw-scan', constructor: KWScan },
            { name: 'tk-file-upload-area', constructor: KWFileUploadArea },
            { name: 'kw-async', constructor: KWAsync },
            { name: 'kw-section-toggler', constructor: KWSectionToggler },
            { name: 'tk-form-timepicker', constructor: TKFormTimepicker },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
            { name: 'kw-dialog', constructor: KWDialog },
            { name: 'tk-form-zip-city', constructor: TKFormZipCity },
            { name: 'kw-tour-schedule', constructor: KWTourSchedule },
            { name: 'tk-table', constructor: TKTable },
            { name: 'tk-tabs-tab', constructor: KWTabsTab },
        ]);
    }
}

new Staticcontent();
